/**
 * 計画の所要時間を `8h50m` 形式にする（サンプル route-planner の MapPage:1745 と同じ書式）。
 * 分は必ず 2 桁。1 時間未満でも `0h45m` と出す。
 *
 * 片方でも時刻が取れなければ null。0h00m と出すと「所要ゼロ」という確定値に見える。
 * 終了が開始より前のデータも null にする（負の所要は表示のしようがない）。
 */
export function formatPlanDuration(start: Date | null, end: Date | null): string | null {
  if (!start || !end) return null;
  const totalMinutes = Math.round((end.getTime() - start.getTime()) / 60000);
  if (totalMinutes < 0) return null;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h${String(minutes).padStart(2, '0')}m`;
}
